import { Link } from 'react-router-dom';

const footerLinks = [
  {
    title: '漫画分类',
    links: [
      { label: '韩漫推荐', href: '/category/korean' },
      { label: '日漫推荐', href: '/category/japanese' },
      { label: '国漫推荐', href: '/category/chinese' },
      { label: '恋爱漫画', href: '/category/romance' },
      { label: '奇幻漫画', href: '/category/fantasy' },
      { label: '热血漫画', href: '/category/action' },
    ],
  },
  {
    title: '关于我们',
    links: [
      { label: '品牌介绍', href: '/about' },
      { label: '联系我们', href: '/about#contact' },
      { label: '用户口碑', href: '/about#reviews' },
    ],
  },
  {
    title: '热门推荐',
    links: [
      { label: '漫画排行榜', href: '/#rankings' },
      { label: '最新更新', href: '/#latest' },
      { label: '热门标签', href: '/#tags' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-book-open-line text-lg"></i>
              </div>
              <span className="font-heading font-bold text-xl text-background-50 whitespace-nowrap">香蕉漫画</span>
            </Link>
            <p className="text-sm text-background-400 leading-relaxed">
              香蕉漫画精选热门韩漫、日漫、国漫分类推荐，涵盖恋爱、奇幻、热血等所有风格，为漫迷提供高清漫画免费在线阅读和人气排行榜。
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-background-200"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-background-200"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="B站">
                <i className="ri-bilibili-line text-background-200"></i>
              </a>
            </div>
          </div>

          {footerLinks.map((section) => (
            <div key={section.title}>
              <h4 className="font-heading font-bold text-background-50 mb-4">{section.title}</h4>
              <ul className="flex flex-col gap-2.5">
                {section.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.href}
                      className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-background-800 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} 香蕉漫画 BananaComic.com 版权所有
          </p>
          <div className="flex items-center gap-4 text-xs text-background-500">
            <a href="#" className="hover:text-background-300 transition-colors whitespace-nowrap">隐私政策</a>
            <a href="#" className="hover:text-background-300 transition-colors whitespace-nowrap">服务条款</a>
            <a href="#" className="hover:text-background-300 transition-colors whitespace-nowrap">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}